import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { UserContext } from '../../User/UserProvider.tsx';
import LoginRedirect from './LoginRedirect';

const InternalBymUserRoute = (props) => {
  const { component: Comp, ...rest } = props;
  const user = useContext(UserContext);
  const auth = useAuth();

  return (
    <Route
      {...rest}
      render={() => {
        if (auth.isLoading || auth.activeNavigator) {
          return null;
        }
        if (!user || !user.isLoggedIn()) {
          return <LoginRedirect vakt="InternalBymUserRoute" />;
        }
        if (user.isInternBymbruker()) {
          return <Comp {...props} />;
        }
        // Uautentisert: send til login-flyten som håndterer feil (access_denied)
        // og gir bruker en tydelig ny-innlogging-knapp. /unauth er blindvei for monitor.
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
};
export default InternalBymUserRoute;
